module.exports = __webpack_public_path__ + "static/media/Globe.5c809547.svg";